// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3cGvA","title":"Info_title__1-Eyf","selects":"Info_selects__19_s2","requiredAsterisk":"Info_requiredAsterisk__3trLj"};